import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { CaseType } from "../_types/case-type";
import { CaseTypeProcessorContract } from "../_types/case-type-processor-contract";

@Injectable({
    providedIn: 'root',
})
export class CasesTypesProcessorContractsService extends Service<CaseTypeProcessorContract> {
    public override type = 'casesTypesProcessorsContracts';
    public override url = 'attendance/casesTypesProcessorsContracts';
}
